import { Component, ElementRef, EventEmitter, HostListener, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SafeHtmlUtils } from '../../utils/safe-html.util';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-html-error',
  templateUrl: './html-error.component.html',
  styleUrls: [
    './html-error.component.scss',
    '../../fragments/modal/modal.fragment.scss'
  ]
})
export class HtmlErrorComponent implements OnInit {

  @ViewChild('modalBody') private modalBody: ElementRef;
  @ViewChild('outsideModal') private outsideModal: ElementRef;

  public closeEmitter = new EventEmitter();

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeModal();
    }
  }

  public set htmlContent(htmlContent: string) {
    this.sanitizedHtml = SafeHtmlUtils.sanitizeHtmlAndBypass(htmlContent, this._domSanitizer);
  }

  public sanitizedHtml: SafeHtml;

  constructor(
    private _domSanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
  }

  public closeModal(): void {
    this.closeEmitter.emit();
  }

}
